import script from "./CustomerActivity.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerActivity.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerActivity.vue?vue&type=style&index=0&id=3b11cdf8&scoped=true&lang=scss"
import "./CustomerActivity.vue?vue&type=style&index=1&id=3b11cdf8&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b11cdf8"]])

export default __exports__